<template>
    <div ref="rootEl">
        <div ref="headerEl">
            <slot name="header"></slot>
        </div>
        <div ref="bodyEl" :data-sticky-container-header-height="headerHeight">
            <slot></slot>
        </div>
    </div>
</template>

<script lang="ts">
const CURRENT_STICKY_TOP = "CURRENT_STICKY_TOP";
</script>

<script lang="ts" setup>
import {
    onMounted,
    provide,
    inject,
    Ref,
    ref,
    watch,
    useTemplateRef,
} from "vue";
import { useResizeObserver } from "@vueuse/core";

const headerEl = useTemplateRef("headerEl");
const bodyEl = useTemplateRef("bodyEl");

const headerHeight = ref<string | undefined>();
const childStickyTop = ref(0);
const parentStickyTop = inject<Ref<number>>(CURRENT_STICKY_TOP, ref(0));
provide(CURRENT_STICKY_TOP, childStickyTop);

const calc = () => {
    if (!headerEl.value) {
        return;
    }

    childStickyTop.value = parentStickyTop.value + headerEl.value.offsetHeight;
    headerHeight.value = "" + headerEl.value.offsetHeight;
};

useResizeObserver(headerEl, () => {
    requestAnimationFrame(() => {
        calc();
    });
});

onMounted(() => {
    calc();

    watch(parentStickyTop, calc);

    watch(
        childStickyTop,
        () => {
            bodyEl.value?.style?.setProperty(
                "--stickyTop",
                `${childStickyTop.value}px`,
            );
        },
        {
            immediate: true,
        },
    );

    headerEl.value.style.position = "sticky";
    headerEl.value.style.top = "var(--stickyTop, 0)";
    headerEl.value.style.zIndex = "1000";
});
</script>

<style lang="scss" module></style>
